import type { MyVenue } from '../../../@api-client';

/** The platform venue that represents the iDU dashboard; an admin grant on it is iDU staff access. */
export const IDU_DASHBOARD_EXTERNAL_ID = 'idu_dashboard_dried_mango';

/**
 * Whether a grant is iDU Dashboard admin access: the dashboard venue, under the `idu_dashboard`
 * application, as admin. The UI half of the API's `mustBeDashboardAdmin()`
 * (`modules/api/src/applications/system/auth/dashboard-venue.ts`); all three parts must match it.
 */
export const isDashboardAdminGrant = (
  venue: Pick<MyVenue, 'externalId' | 'application' | 'role'>,
): boolean =>
  venue.externalId === IDU_DASHBOARD_EXTERNAL_ID &&
  venue.application === 'idu_dashboard' &&
  venue.role === 'admin';
